import React from 'react';
import ProfessionalsAddEmployeeContactInfo from '../../../components/professionals/ProfessionalsAddEmployeeContactInfo';
import { useSubmitFlexProfessionalContactInfoMutation } from '../../../redux/managementCompanyWorkforce';
import { ERROR_CODES } from '../../../constants/Errors';
import MESSAGE_MAP from '../../../constants/FlexProfessionalMessagesMap';
import warningIcon from '../../../assets/images/warning-icon-2.svg';

const { FLEX_PROFESSIONAL_ERROR_CODES } = ERROR_CODES;

const FlexProfessionalsCreateEmployeeContactInfo = ({ managementCompanyId, handleNavigateToNextStep }) => {
	const [submitContactInfo, { isLoading: isSaving }] = useSubmitFlexProfessionalContactInfoMutation();

	const submitForm = ({ body }) => submitContactInfo({ managementCompanyId, body });

	return (
		<ProfessionalsAddEmployeeContactInfo
			isSaving={isSaving}
			submitForm={submitForm}
			handleNavigateToNextStep={handleNavigateToNextStep}
			errorCodes={FLEX_PROFESSIONAL_ERROR_CODES}
			messageMap={MESSAGE_MAP}
			bannerIcon={warningIcon}
			bannerClassName="flex-workforce"
			containerClassName="flex-workforce"
			confirmLeaveWhenDirty
			bannerErrorCodes={[FLEX_PROFESSIONAL_ERROR_CODES.CONTACT_US, FLEX_PROFESSIONAL_ERROR_CODES.ALREADY_EXISTS]}
			existingMethodName="addExistingProfessionalToManagementCompany"
			existingProfessionalMessage="This professional already exists. A message has been sent to their mobile app asking for their approval to join your workforce."
		/>
	);
};

export default FlexProfessionalsCreateEmployeeContactInfo;
